// TODO - use symbol
export const OWNER = '__owner__';
export function getOwner(object) {
    return object[OWNER];
}
export function setOwner(object, owner) {
    object[OWNER] = owner;
}